<div class="overlay basin-width-100 basin-height-100">
  <div class="p-d-flex p-jc-center p-ai-center basin-width-100 basin-height-100">
    <div class="basin-background-white basin-p-4 rounded overlay-content">
      <div class="basin-display-flex basin-flex-column basin-align-items-center">
        <basin-circled-icon icon="symbol-waving-hand" size="large" theme="blue"></basin-circled-icon>
        <h5 class="basin-pt-4 basin-text-align-center">Welcome to <br />DebrisFlow Predictor</h5>
        <div class="basin-pt-4 basin-pb-4">Use the side panel to create or select a study area.</div>
        <button pButton icon="symbol-help" label="USER GUIDE AND FAQs" (click)="openJiraLink()"></button>
      </div>
    </div>
  </div>
</div>